import React from "react";
import { Button } from "antd";
import { useTitle } from "../hooks/useTitle";
import { useTranslation } from "react-i18next";
import UserTable from "../components/UserTable/UserTable";
import { useNavigate } from "react-router-dom";

const UserPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useTitle(t("page-title.users"));

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 1000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-end",
        marginTop: "2.5rem",
      }}
    >
      <Button
        onClick={() => navigate("/portal/add-user")}
        style={{ paddingInline: "1.2rem", marginBottom: "0.5rem" }}
      >
        {t("pages.users.add-user")}
      </Button>
      <UserTable />
    </div>
  );
};

export default UserPage;
